import { APP_HOME_PATHNAME, MobileFooterTag } from '@/types/common'
import { usePathname } from 'next/navigation'
import { useMemo } from 'react'
import { homeMobilePageState } from 'Store/home'
import { useRecoilValue } from 'recoil'
import useI18n from 'Hooks/useI18n'
import { withLocale } from '@/locales'

export const useGetHomeRoute = () => {
  const { lang } = useI18n()
  const path = usePathname()
  const homePage = useRecoilValue(homeMobilePageState)

  const currentBaseRoute = useMemo(() => {
    if (path === withLocale(APP_HOME_PATHNAME, lang)) {
      if (homePage === 'grid') {
        return MobileFooterTag.Explore
      }
      return MobileFooterTag.Home
    } else if (path.startsWith(withLocale('/chat', lang))) {
      return MobileFooterTag.Chat
    } else if (path.startsWith(withLocale('/create', lang))) {
      return MobileFooterTag.Create
    } else if (path.startsWith(withLocale('/profile', lang))) {
      return MobileFooterTag.Profile
    } else {
      return null
    }
  }, [path, lang, homePage])

  return {
    currentBaseRoute,
  }
}
